import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Route, useHistory } from "react-router";
import { Spin, Button, Space, Divider, Tooltip } from "antd";
import {
  updateLine,
  fetchStatement,
  processBatch,
  resetStatement,
} from "../../store/slices/statements";
import StatementDetails from "../../components/statements/StatementDetails/StatementDetails";
import { checkIsLoading, checkIsLoaded } from "../../lib/utils/checkLoadingStatus";

const StatementDetailsContainer = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { statementId } = useParams();
  // console.log(statementId);
  const { statement, statementLoading } = useSelector((state) => state.statements);
  const [inProcess, setInProcess] = useState(false);
  const [isReadyToProcessable, setIsReadyToProcessable] = useState(false);

  const isEditable = statement?.batchInfo?.batchStatusReduced === "EDITABLE";

  useEffect(() => {
    if (checkIsLoaded(statementLoading)) {
      setIsReadyToProcessable(statement.batchInfo.isProcessable);
    }
  }, [statement, statementLoading]);

  const handleSetProcessableStatus = (status) => {
    setIsReadyToProcessable(status);
  };

  const isStatementLoading = checkIsLoading(statementLoading);
  const isStatementLoaded = checkIsLoaded(statementLoading);

  useEffect(() => {
    dispatch(fetchStatement({ statementId }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /*
    Описание handleUpdateLine
    При сборке тела запроса собираются:
     - клиенты: только те, у которых во вложенных счетах есть goalAmount
     - договоры: только те, у которых во вложенных счетах есть goalAmount
     - счета: только те, у которых есть goalAmount
  */
  const handleUpdateLine = ({ line, updatedAgreementHolder = {} }) => {
    const getGoalHolder = ({ bill, goal }) => ({
      billNumber: bill?.billNumber,
      goalAmount: goal?.amount,
    });

    const getAgreementHolder = ({ agreement, goalHolders, balanceAmount }) => {
      return {
        agreementId: agreement?.id,
        goalHolders: goalHolders.filter(({ goal }) => goal).map(getGoalHolder),
        balanceAmount,
      };
    };

    const filterAgreementHolder = (agreementHolder) => {
      let hasAmounts = false;
      if (agreementHolder.balanceAmount) hasAmounts = true;
      agreementHolder.goalHolders.forEach(({ goalAmount }) => {
        if (goalAmount) hasAmounts = true;
      });
      return hasAmounts;
    };

    const getAccountHolder = ({ account, agreementHolders }) => ({
      accountId: account.id,
      agreementHolders: agreementHolders
        .map((agreementHolder) => {
          const agreementId = agreementHolder?.agreement?.id;
          if (agreementId && agreementId === updatedAgreementHolder?.agreement?.id) {
            // console.log(updatedAgreementHolder);
            // console.log("1");
            return getAgreementHolder(updatedAgreementHolder);
          }
          // console.log("2");
          return getAgreementHolder(agreementHolder);
        })
        .filter(filterAgreementHolder),
    });

    const filterAccountHolder = (accountHolder) => {
      let hasAmounts = false;
      accountHolder.agreementHolders.forEach((agreementHolder) => {
        if (agreementHolder.balanceAmount) hasAmounts = true;
        agreementHolder.goalHolders.forEach(({ goalAmount }) => {
          if (goalAmount) hasAmounts = true;
        });
      });
      return hasAmounts;
    };

    const updatedAccountHolders = line.accountHolders
      .map(getAccountHolder)
      .filter(filterAccountHolder);

    // return console.log(updatedAccountHolders);
    return dispatch(updateLine({ lineId: line.line.id, updatedAccountHolders })).then(
      ({ payload }) => payload
    );
  };

  const handleProcessBatch = () => {
    setInProcess(true);
    dispatch(processBatch(statement.batch.id)).finally(() => {
      history.push("/statements");
    });
  };

  return (
    <Spin className="spin" spinning={isStatementLoading}>
      <Route path="/statements/:statementId">
        <StatementDetails
          statement={statement}
          isStatementLoaded={isStatementLoaded}
          handleUpdateLine={handleUpdateLine}
          resetStatement={() => dispatch(resetStatement())}
          handleSetProcessableStatus={handleSetProcessableStatus}
          isEditable={isEditable}
        />
        {isStatementLoaded && (
          <>
            <div style={{ width: "250px", margin: "25px auto 16px auto" }}>
              <Space>
                <Button style={{ width: "128px" }} onClick={() => history.push("/statements")}>
                  Назад
                </Button>
                {isEditable && (
                  <Tooltip title={isReadyToProcessable ? "" : "Необходимо обработать все платежи"}>
                    <Button
                      style={{ width: "128px" }}
                      type="primary"
                      onClick={handleProcessBatch}
                      disabled={!isReadyToProcessable}
                      loading={inProcess}
                    >
                      Обработать
                    </Button>
                  </Tooltip>
                )}
              </Space>
            </div>
            <Divider />
          </>
        )}
      </Route>
    </Spin>
  );
};

export default StatementDetailsContainer;
